import { render, staticRenderFns } from "./IgrejadaLiberdade.vue?vue&type=template&id=468baaf4&scoped=true"
import script from "./IgrejadaLiberdade.vue?vue&type=script&lang=js"
export * from "./IgrejadaLiberdade.vue?vue&type=script&lang=js"
import style0 from "./IgrejadaLiberdade.vue?vue&type=style&index=0&id=468baaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468baaf4",
  null
  
)

export default component.exports